import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Img01 from '../../img/about-us-main.png'
import { Box, Container, Divider, Typography, useMediaQuery } from '@material-ui/core';
import { withNamespaces } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    // ----------------------------------------------------
    shader: {
        backgroundColor: "#F7F7F7"
    },
    fontFamily: {
        fontFamily: `'Roboto', sans-serif`,
        lineHeight: 1.25
    },
    blockGrid: {
        minHeight: 100,
    },
    contentHeadTitle: {
        fontWeight: "bold",
        fontSize: "3.5vw",
        [theme.breakpoints.down("sm")]: {
            fontSize: 30,
        },
    },
    contentTitle: {
        fontWeight: "bold",
        fontSize: 45,
        paddingTop: 20,
        [theme.breakpoints.down("sm")]: {
            fontSize: 30,
        },
    },
    contentSubtitle: {
        color: "#1E90FF",
        fontSize: 20,
        fontWeight: "bold",
        paddingTop: 40
    },
    contentGrid: {
        flex: 1,
    },
    content: {
        padding: 20,
        paddingLeft: 40,
        paddingRight: 40,
        paddingTop: 0,
        textAlign: "justify",
        fontWeight: 100,
        [theme.breakpoints.down("sm")]: {
            fontSize: 14,
        },
        [theme.breakpoints.up("md")]: {
            fontSize: "1.5vw",
        },
        [theme.breakpoints.up("lg")]: {
            fontSize: "1vw",
        },

    },
    CalculatorTitle: {
        textAlign: "center",
        fontSize: 30
    },
    CalculatorSubTitle: {
        textAlign: "center",
        fontSize: 25
    },
    pt20: {
        paddingTop: 20
    }
}));

function AboutUsMain({ t }) {
    const theme = useTheme();
    const classes = useStyles();
    const themeMainColor = theme.palette.primary.main
    let isOverMd = useMediaQuery(theme.breakpoints.up('md'))
    let gridWidth = 450

    const RowContent = ({ contentTitle, content1, content2 }) => {
        return (
            <Grid container item direction="row" justify="center">
                <Grid container item justify="flex-start" alignItems="center" style={{ maxWidth: gridWidth }} direction="column">
                    <Typography className={classes.contentSubtitle}>
                        {contentTitle}
                    </Typography>
                    <Typography className={classes.content}>
                        <i>{content1}</i>
                    </Typography>
                </Grid>
                <Divider orientation="vertical" flexItem />
                <Grid container item justify="flex-start" alignItems="center" style={{ maxWidth: gridWidth }} direction="column">
                    <Typography className={classes.contentSubtitle}>
                        {contentTitle}
                    </Typography>
                    <Typography className={classes.content}>
                        <i>{content2}</i>
                    </Typography>
                </Grid>
            </Grid>
        )
    }

    return (
        <Grid className={classes.fontFamily}>
            <div style={{ paddingTop: 70 }} />
            <Grid container item direction="row" alignItems="center" className={classes.shader}>
                <Grid item lg={8} md={6} xs={12}>
                    <img src={Img01} alt="img01"
                        style={{
                            marginLeft: "auto",
                            marginRight: "auto",
                            display: "block",
                            width: "100%"
                        }} />
                </Grid>

                <Grid item container lg={4} md={6} xs={12} direction="column" alignItems="center">
                    <Grid item>
                        <Typography className={classes.contentHeadTitle}>
                            {t("about-us")}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Typography className={classes.content}>
                            {t("mylife-network")}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Typography className={classes.content}>
                            {t("create-awareness")}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
            {/* //testing */}
            {isOverMd ?
                <Grid container item direction="column" alignItems="center">
                    <Grid container item direction="row" justify="center">
                        <Grid container item justify="center" style={{ maxWidth: gridWidth }}>
                            <Typography className={classes.contentTitle}>
                                {t("our-values")}
                            </Typography>
                        </Grid>
                        <Divider orientation="vertical" flexItem />
                        <Grid container item justify="center" style={{ maxWidth: gridWidth }}>
                            <Typography className={classes.contentTitle}>
                                {t("our-solution")}
                            </Typography>
                        </Grid>
                        <RowContent contentTitle={t("awareness")} content1={t("awareness-content-1")} content2={t("awareness-content-2")} />
                        <RowContent contentTitle={t("prevention")} content1={t("prevention-content-1")} content2={t("prevention-content-2")} />
                        <RowContent contentTitle={t("simplicity")} content1={t("simplicity-content-1")} content2={t("simplicity-content-2")} />
                    </Grid>

                </Grid>
                :
                <Grid container item direction="row" alignItems="center" justify="center">
                    <Grid container item direction="column" style={{ width: gridWidth }} alignItems="center">
                        <Typography className={classes.contentTitle}>
                            {t("our-values")}
                        </Typography>
                        <Typography className={classes.contentSubtitle}>
                            {t("awareness")}
                        </Typography>
                        <Typography className={classes.content}>
                            {t("awareness-content-1")}
                        </Typography>
                        <Typography className={classes.contentSubtitle}>
                            {t("prevention")}
                        </Typography>
                        <Typography className={classes.content}>
                            {t("prevention-content-1")}
                        </Typography>
                        <Typography className={classes.contentSubtitle}>
                            {t("simplicity")}
                        </Typography>
                        <Typography className={classes.content}>
                            {t("simplicity-content-1")}
                        </Typography>
                        <Typography className={classes.contentTitle}>
                            {t("our-solution")}
                        </Typography>
                        <Typography className={classes.contentSubtitle}>
                            {t("awareness")}
                        </Typography>
                        <Typography className={classes.content}>
                            {t("awareness-content-2")}
                        </Typography>
                        <Typography className={classes.contentSubtitle}>
                            {t("prevention")}
                        </Typography>
                        <Typography className={classes.content}>
                            {t("prevention-content-2")}
                        </Typography>
                        <Typography className={classes.contentSubtitle}>
                            {t("simplicity")}
                        </Typography>
                        <Typography className={classes.content}>
                            {t("simplicity-content-2")}
                        </Typography>
                    </Grid>
                </Grid>
            }
        </Grid>
        //testing

    );
}
export default withNamespaces()(AboutUsMain)